import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["modal", "input", "card",
                    "placeholder", "selectedCard"]

  connect() {
    this._onKeydown = this.onKeydown.bind(this)
    document.addEventListener("keydown", this._onKeydown)
  }

  disconnect() {
    document.removeEventListener("keydown", this._onKeydown)
  }

  onKeydown(e) {
    if (e.key !== "Escape") return
    if (this.modalTarget.classList.contains("hidden")) return

    const searchEl = this.element.querySelector("[data-controller='equipment-search']")
    if (searchEl) {
      const searchController = this.application.getControllerForElementAndIdentifier(searchEl, "equipment-search")
      if (searchController?.enabled) return
    }

    this.close()
  }

  // ----- Open/close -----

  open() {
    this.modalTarget.classList.remove("hidden")
  }

  close() {
    this.modalTarget.classList.add("hidden")

    const searchEl = this.element.querySelector("[data-controller='equipment-search']")
    if (searchEl) {
      const searchController = this.application.getControllerForElementAndIdentifier(searchEl, "equipment-search")
      if (searchController && searchController.enabled) {
        searchController.reset()
      }
    }
  }

  closeIfBackdrop(event) {
    if (event.target === this.modalTarget) this.close()
  }

  // ----- Selection -----

  select(event) {
    const card = event.currentTarget
    const id = card.dataset.equipmentId

    this.inputTarget.value = id
    this.placeholderTarget.classList.add("hidden")

    this.selectedCardTargets.forEach(selectedCard => {
      if (selectedCard.dataset.equipmentId === id) {
        selectedCard.classList.remove("hidden")
      } else {
        selectedCard.classList.add("hidden")
      }
    })

    this.close()
  }

  selectById(id) {
    this.inputTarget.value = id
    this.placeholderTarget.classList.add("hidden")

    this.selectedCardTargets.forEach(selectedCard => {
      if (selectedCard.dataset.equipmentId === id.toString()) {
        selectedCard.classList.remove("hidden")
      } else {
        selectedCard.classList.add("hidden")
      }
    })
  }

  // ----- Filtering -----

  filterRarity(event) {
    this.toggleFilter("rarity", event.currentTarget)
  }

  filterZeroSystem(event) {
    this.toggleFilter("zero_system", event.currentTarget)
  }

  toggleFilter(filterKey, button) {
    const isActive = button.dataset.active === "true"
    const groupSelector = `[data-filter-group="${filterKey}"]`

    this.element.querySelectorAll(groupSelector).forEach(b => {
      b.dataset.active = "false"
      b.classList.add("brightness-50")
    })

    if (!isActive) {
      button.dataset.active = "true"
      button.classList.remove("brightness-50")
    }

    this.applyFilters()
  }

  applyFilters() {
    const activeRarity = this.activeFilterValue("rarity")
    const activeZeroSystem = this.activeFilterValue("zero_system")

    const searchEl = this.element.querySelector("[data-controller='equipment-search']")
    const searchController = searchEl
      ? this.application.getControllerForElementAndIdentifier(searchEl, "equipment-search")
      : null
    const searchTerm = searchController?.hasInputTarget
      ? searchController.inputTarget.value.toLowerCase()
      : ""

    this.cardTargets.forEach(card => {
      const matchesRarity = !activeRarity || card.dataset.rarity === activeRarity
      const matchesZeroSystem = !activeZeroSystem || card.dataset.zeroSystem === activeZeroSystem
      const matchesSearch = !searchTerm || card.dataset.equipmentName.toLowerCase().includes(searchTerm)

      const visible = matchesRarity && matchesZeroSystem && matchesSearch
      card.classList.toggle("hidden", !visible)
    })
  }

  activeFilterValue(filterKey) {
    const button = this.element.querySelector(`[data-filter-group="${filterKey}"][data-active="true"]`)
    return button ? button.dataset.filterValue : null
  }
}
